
import {
  IconEyes,
  IconSparkles,
  RevButtonBase,
} from '@backmarket/design-system'

import { tw } from '@core/tailwind'

import PickersList from '../PickersList'

const ICONS = {
  IconEyes,
  IconSparkles,
}

const HIGHLIGHTED_PICKERS_VARIANTS = {
  info: 'info',
  accent: 'accent',
}

export default {
  components: {
    RevButtonBase,
    PickersList,
  },

  props: {
    highlightedPickers: {
      type: Array,
      default: () => [],
    },
    selectedHighlightedPickers: {
      type: Object,
      default: null,
    },
  },

  data() {
    return {
      pickers: [],
    }
  },

  computed: {
    pickersListClasses() {
      return tw`grid gap-2 grid-cols-${this.pickers.length}`
    },
  },

  watch: {
    selectedHighlightedPickers(newPicker, oldPicker) {
      if (newPicker !== oldPicker) {
        this.pickers = [...this.highlightedPickers]
      }
    },
  },

  created() {
    this.pickers = [...this.highlightedPickers]
  },

  mounted() {
    this.pickers = [...this.highlightedPickers]
  },

  methods: {
    pickerStyle(type, isSelected) {
      if (type === HIGHLIGHTED_PICKERS_VARIANTS.info) {
        const shared = tw`border-info hover:bg-info-ultralight hover:text-primary`
        const selected = isSelected
          ? tw`bg-info-ultralight text-primary`
          : tw`text-info`

        return `${shared} ${selected}`
      }

      if (type === HIGHLIGHTED_PICKERS_VARIANTS.accent) {
        const shared = tw`border-accent hover:bg-accent-ultralight hover:text-primary`
        const selected = isSelected
          ? tw`bg-accent-ultralight text-primary`
          : tw`text-accent`

        return `${shared} ${selected}`
      }

      const shared = tw`bg-secondary border-neutral focus:border-primary-active hover:bg-secondary-hover hover:border-primary-hover text-primary`
      const selected = isSelected
        ? tw`bg-secondary-selected border-primary-active`
        : ''

      return `${shared} ${selected}`
    },

    pickersIcon(icon) {
      return ICONS[icon]
    },

    handlePickerClick(index) {
      this.$emit('highlighted-picker-click', index)
    },
  },
}
